export default __webpack_public_path__ + "static/media/apphiveLogo.3e3c4447.png";